// Clustering pin pelanggan di Peta Pelanggan (fase 3, 2026-09-20) -- grid sederhana, sengaja TANPA
// leaflet.markercluster: pin yg digambar cuma ratusan, jadi grid piksel ~40 baris cukup & tidak
// menambah dependensi (lock file/Docker build ikut berubah). CommonJS supaya file ini bisa dites
// langsung dari app/test (node --test) sekaligus di-import webpack CRA.

// Di zoom >= ini semua pin digambar satuan (cukup dekat utk dibedakan); di bawahnya digrup per sel.
const CLUSTER_MAX_ZOOM = 16
// Ukuran sel grid dalam piksel layar pada zoom saat ini -- pin yg jatuh di sel sama digabung.
const CELL_PX = 56
const WARNA_KLUSTER_CAMPUR = '#6366f1'

// points: [{ x, y, lat, lng, ... }] dgn x,y = koordinat piksel dunia pada zoom SAAT INI
// (map.project). Balikin [{ members, lat, lng }] -- lat/lng = rata-rata anggota (posisi bubble).
// Sel berisi 1 titik tetap dikembalikan sbg grup 1 anggota; pemanggil yg memutuskan menggambarnya
// sbg pin satuan.
function gridCluster(points, cellPx = CELL_PX) {
  const sel = new Map()
  for (const p of points) {
    const key = `${Math.floor(p.x / cellPx)}:${Math.floor(p.y / cellPx)}`
    const g = sel.get(key)
    if (g) g.push(p); else sel.set(key, [p])
  }
  return [...sel.values()].map(members => ({
    members,
    lat: members.reduce((a, m) => a + m.lat, 0) / members.length,
    lng: members.reduce((a, m) => a + m.lng, 0) / members.length
  }))
}

// Warna bubble: kalau semua anggota satu warna -> pakai warna itu, selain itu abu tua netral.
function warnaKluster(warnaAnggota) {
  const uniq = new Set(warnaAnggota)
  return uniq.size === 1 ? [...uniq][0] : WARNA_KLUSTER_CAMPUR
}

module.exports = { CLUSTER_MAX_ZOOM, CELL_PX, WARNA_KLUSTER_CAMPUR, gridCluster, warnaKluster }
